import { render, staticRenderFns } from "./paymentInstructions.vue?vue&type=template&id=7fca4274&scoped=true"
import script from "./paymentInstructions.vue?vue&type=script&lang=js"
export * from "./paymentInstructions.vue?vue&type=script&lang=js"
import style0 from "./paymentInstructions.vue?vue&type=style&index=0&id=7fca4274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fca4274",
  null
  
)

export default component.exports